<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconjigou1"></i>
      填报志愿管理
    </div>
    <div class="padding-sm">

      <div class="flex align-center condition-warpper">

        <el-select v-model="gangwei" placeholder="请选择实习岗位" class="margin-right-sm">
          <el-option
              v-for="item in gangweiLiset"
              :key="item.sx_id"
              :label="item.sx_name"
              :value="item.sx_id">
          </el-option>
        </el-select>
        <el-button type="primary" @click="onSearch">
          <p class="flex align-center font-size">
            <i class="el-icon-search margin-right-xs"></i>搜索
          </p>
        </el-button>
      </div>

      <el-tabs v-model="activeName" @tab-click="handleClick" class="margin-tb-xs">
        <el-tab-pane label="第一志愿" name="1"></el-tab-pane>
        <el-tab-pane label="第二志愿" name="2"></el-tab-pane>
        <el-tab-pane label="第三志愿" name="3"></el-tab-pane>
      </el-tabs>
      <el-table
          :data="volunteerList"
          header-row-class-name="table-header"
          row-class-name="table-row"
          alig="center"
          fit
          style="width: 100%"
          @selection-change="handleSelectionChange"
      >
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column label="学生姓名">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.stu_name }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="所在院校">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.org_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="所在年级">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.class_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="查看详情">
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button
                  size="medium"
                  type="primary"
                  @click="showItem(scope.row.stu_id)"
              >查看详情
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="multipleSelection.length>0" class="margin-top">
        <el-button
            class="submit-btn"
            size="medium"
            type="primary"
            @click="setItemStatus(1)"
        >审核通过
        </el-button>
        <el-button
            class="submit-btn"
            size="medium"
            type="danger"
            @click="setItemStatus(-1)"
        >审核拒绝
        </el-button>
      </div>
    </div>

    <stu-dialog :subdialogDialog="dialog" :setId="setId" @cancelDialog="cancelDialog"/>
  </div>
</template>

<script>
import {xieStationList, xietiaoVolunteer, xietiaoVolunteerStatus} from "@/api/coordinate";
import stuDialog from "@/views/coordinate/page/dialog/stuDialog";

export default {
  name: "volunteer",
  data() {
    return {
      gangweiLiset: [],
      gangwei: '',
      activeName: '1',
      volunteerList: [],
      multipleSelection: [],
      dialog: false,
      setId: 0
    };
  },
  components: {stuDialog},
  created() {
    this.$emit(
        "setIndex",
        '/coordinate/practice3',
        "当前位置：实习基地数据 > 填报志愿管理",
        true
    );
    this.init()
  },
  methods: {
    async init() {
      let _list = await xieStationList(this.$route.query.id, 1)
      this.gangweiLiset = _list.data
      if (this.gangweiLiset.length > 0) {
        this.gangwei = _list.data[0].sx_id
        this.getList()
      } else {
        this.volunteerList = []
        this.multipleSelection = []
      }

    },
    async getList() {
      let _list = await xietiaoVolunteer(this.$route.query.id, Number(this.activeName), this.gangwei, 1, 1000)
      this.volunteerList = _list.data.list
    },
    onSearch() {
      this.getList()
    },
    handleClick(tab) {
      this.getList()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    setItemStatus(num) {
      this.$confirm(num === 1 ? "确定要审核通过吗？" : "确定要拒绝吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureSet(num);
      });
    },
    async sureSet(num) {
      let arr = []
      this.multipleSelection.map(item => {
        arr.push(item.zy_id)
      })
      let _state = await xietiaoVolunteerStatus(arr.join(','), num);
      this.init();
      this.$message.success(_state.msg);
    },

    showItem(id) {
      this.setId = id
      this.dialog = true
    },
    cancelDialog() {
      this.setId = 0
      this.dialog = false
    }


  },
  watch: {
    activeName() {
      this.getList()
    }
  }
}
</script>

<style scoped lang="scss">

</style>